<template>
    <form class="form-signin" autocomplete="off">
        <div>
            <input
                :type="this.inputType"
                name="pin"
                id="pin"
                class="form-control form-control--large"
                :placeholder="$t('labels.enter_pin')"
                v-model="pin"
                @keydown.enter.prevent="evaluateInput"
                disabled
                >
        </div>

    </form>
</template>

<script>
    import { writeTrackLog } from "../utils/tracking";

    export default {
        data() {
            return {
                pin: '',
                processing: false,
                error: null,
                success: null
            }
        },

        methods: {
            type(value) {
                if (this.pin.length < 4) {
                  this.onChange(this.pin + value);
                }
            },

            onChange(value) {
              if(value.length === 4) {
                this.pin = '';
                window.events.$emit('disableNumpad');
                this.handlePin(value);
              } else {
                this.pin = value;
              }
            },

            onSubmit() {
              var value = this.pin;
              this.pin = '';
              if (value.length === 0) {
                return;
              }

              window.events.$emit('disableNumpad');

              if(value.length < 4) {
                value = value.padStart(4, '0');
              }

              this.handlePin(value);
            },

            handlePin(pin) {
              console.log('handlePin', pin);
                this.$store.dispatch('clearErrors');
                const employee = this.$store.getters.employeeByPin(pin);

                if (employee === undefined || employee === null) {
                    this.$store.dispatch('setError', 'errors.unknown_pincode');
                    window.events.$emit('enableNumpad');
                } else {
                    this.$store.dispatch('setCurrentEmployee', employee);

                    if (this.currentDevice.register_workdays) return this.$router.push({name: 'workday'});

                    return this.$router.push({name: 'activity'});
                }
            },

            evaluateInput() {
                const val = document.getElementById('pin').value;
                if (val.length === 4 && !isNaN(val)) this.handlePin();
                this.pin = '';
            }
        },

        computed: {
            currentDevice () {
                return this.$store.getters.currentDevice
            },

            currentEmployee () {
                return this.$store.getters.currentEmployee
            },

            currentWorkday () {
                return this.$store.getters.currentWorkday
            },

            pinVisible () {
              return this.$store.state.pinVisible;
            },

            inputType () {
              return this.pinVisible ? 'text' : 'password';
            },
        },

        mounted() {
			if (this.$store.state.enableTracking) writeTrackLog("VIEW: Pin");
            this.$parent.preRegistering = false;

            window.events.$emit('enableNumpad');

          window.events.$on('numpadValue', value => {
            if(document.getElementById('pin')) this.onChange(value);
          });


          window.events.$on('submitFromNumpad', () => {
            this.onSubmit();
          })

            // window.events.$on('numpadType', value => {
            //     if(document.getElementById('pin')) this.type(value);
            // });

            // window.events.$on('backspace', () => {
            //     if (document.getElementById('pin')) this.onChange('');
            // });
        },

        beforeDestroy () {
            window.events.$off('numpadValue');
            window.events.$off('numpadType');
            window.events.$off('backspace');
            window.events.$off('submitFromNumpad');
        }
    }
</script>
